export default "__VITE_ASSET__CGLe$hO3__"